import {Component} from '@angular/core'

@Component({
  selector: 'smt-about',
  imports: [],
  templateUrl: './about.html',
  styleUrl: './about.scss',
})
export class About {

}
